import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetContentImageQuery } from '@store/api';

interface AuthenticatedImageState {
  src: string;
  isLoading: boolean;
  isError: boolean;
}

/**
 * Thin store-composition wrapper (feature 107): reads the authenticated content image from
 * the store's `mediaService` (a base64 data URL) instead of issuing a direct `fetch` and
 * managing object-URL lifecycle. Falls back to `placeholderSrc` while loading or on error.
 */
export function useAuthenticatedImage(
  blobName: string | undefined | null,
  placeholderSrc: string
): AuthenticatedImageState {
  const { data, isLoading, isFetching, isError } = useGetContentImageQuery(
    blobName ? blobName : skipToken
  );

  if (!blobName) {
    return { src: placeholderSrc, isLoading: false, isError: false };
  }

  if (isError) {
    return { src: placeholderSrc, isLoading: false, isError: true };
  }

  if (data?.dataUrl) {
    return { src: data.dataUrl, isLoading: false, isError: false };
  }

  return { src: placeholderSrc, isLoading: isLoading || isFetching, isError: false };
}
